// extracted by mini-css-extract-plugin
export default {"container":"typography_container__6xPVj","text":"typography_text__7K99z"};